import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { injectIntl, IntlProvider } from 'react-intl';

import config, { getCurrentLanguage } from '../containers/LanguageSwitcher/config';
import AppLocale from '../languageProvider';
import translateErrorFields from './translateErrorFields';
import { basePath } from '../v2/baseRouter';

const redirectToLogin = () => {
  window.location.href = basePath;
};

const ErrorContent = ({ intl, code, msg, moduleName = null, functionName = null }) => {
  const isMMRMErrorCode = /^0x[\dA-F]{8}$/.test(code);

  const errorCode = isMMRMErrorCode && `代碼： ${code}`;

  let errorMessage = [];
  if (moduleName && isMMRMErrorCode && code === '0x00000002') {
    errorMessage.push(<br />);
    errorMessage.push('-------------------------------------');
    translateErrorFields(intl, JSON.parse(msg), moduleName, functionName).forEach(value => {
      errorMessage.push(<div>{value}</div>);
    });
    errorMessage.push(<br />);
  } else if (isMMRMErrorCode) {
    errorMessage = intl.formatMessage({ id: `error.${code}` });
  } else {
    errorMessage.push(<br />);
    errorMessage.push('-------------------------------------');
    errorMessage.push(<br />);
    const msgs = Array.isArray(msg) ? msg : msg.split(',');
    msgs.forEach(value => {
      errorMessage.push(<div>{value}.</div>);
    });
  }

  return (
    <span>
      {errorCode}
      <br />
      訊息：
      {errorMessage}
      <br />
    </span>
  );
};

const IntlInjectedErrorContent = injectIntl(ErrorContent);

const currentAppLocale = AppLocale[getCurrentLanguage(config.defaultLanguage || 'english').locale];

ErrorContent.propTypes = {
  code: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  msg: PropTypes.string,
};

ErrorContent.defaultProps = {
  msg: null,
};

const ERROR_CODES_SHOULD_TRIGGER_REDIRECT = ['0x00000004', '0x00000005'];

export function handleError(error, moduleName = null, functionName = null) {
  console.error(`API error with status code ${error.code} ${error.message}`);
  const { code } = error;
  Modal.error({
    title: '發生錯誤',
    content: (
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <IntlInjectedErrorContent
          code={code}
          msg={error.message}
          moduleName={moduleName}
          functionName={functionName}
        />
      </IntlProvider>
    ),
    onOk: () => {
      if (ERROR_CODES_SHOULD_TRIGGER_REDIRECT.includes(code)) {
        redirectToLogin();
      }
    },
  });
}

export default handleError;
